import { render, staticRenderFns } from "./storeRadio.vue?vue&type=template&id=2c200812&scoped=true"
import script from "./storeRadio.vue?vue&type=script&lang=js"
export * from "./storeRadio.vue?vue&type=script&lang=js"
import style0 from "./storeRadio.vue?vue&type=style&index=0&id=2c200812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c200812",
  null
  
)

export default component.exports